import Client from './client';

export default class PartnerOrganizationAuthorizations extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/partner-organization-authorizations`, options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/partner-organization-authorizations`, {
      ...options,
       method: 'POST',
    });
  }

  getById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/partner-organization-authorizations/${id}`, options);
  }

  deleteById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/partner-organization-authorizations/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
